import { FC, memo } from 'react'

import { DatePicker } from 'ui/components/DatePicker'
import { FieldSet } from 'ui/components/FieldSet'
import { Validators } from 'ui/components/Form'
import { Hr } from 'ui/components/Hr'
import { EINInput } from 'ui/components/InputV2/EINInput'
import { Select } from 'ui/components/Select'
import { Col, FormRow } from 'ui/themes/globalStyles'

import { AccountDetailsProps } from './AccountDetailsProps'

import * as SC from './styles'

export const AccountDetails: FC<AccountDetailsProps> = memo(({ isConsumerAccount, Field, companyData }) => {
  const { businessTypeOptions, stateOptions, entityTypeOptions } = companyData

  const leftSideFields = [
    <Field
      required
      name="businessType"
      label="Business Type"
      input={Select}
      inputProps={{
        data: businessTypeOptions,
        'data-qa': 'Business Type',
        'options-data-qa': 'input options'
      }}
      validator={Validators.required.field}
    />,
    <Field
      required
      name="entityType"
      label="Entity Type"
      input={Select}
      inputProps={{
        'data-qa': 'Entity Type',
        'options-data-qa': 'input options',
        data: entityTypeOptions
      }}
      validator={Validators.required.field}
    />,
    <Field
      required
      name="stateFounded"
      label="State of Organization"
      input={Select}
      inputProps={{
        'data-qa': 'State of Organization',
        'options-data-qa': 'input options',
        data: stateOptions
      }}
      validator={Validators.required.field}
    />
  ]

  const rightSideFields = [
    <Field
      name="primaryAccountOpeningDate"
      label="Primary Account Opening Date"
      input={DatePicker}
      inputProps={{
        'data-qa': 'Primary Account Opening Date'
      }}
    />,
    <Field
      name="ein"
      label={isConsumerAccount ? 'EIN/TIN #' : 'EIN #'}
      input={EINInput}
      inputProps={{
        autoComplete: 'new-password',
        'data-lpignore': true,
        'data-qa': isConsumerAccount ? 'EIN/TIN #' : 'EIN #'
      }}
      required
      validator={Validators.required.string}
    />
  ]

  return (
    <FieldSet legend="Account Details">
      <SC.RowsWrapper>
        {new Array(Math.max(leftSideFields.length, rightSideFields.length)).fill(0).map((_, field_index) => (
          <FormRow key={field_index}>
            <Col>{leftSideFields[field_index] || <div />}</Col>
            <Col>{rightSideFields[field_index] || <div />}</Col>
          </FormRow>
        ))}
      </SC.RowsWrapper>
      <Hr />
    </FieldSet>
  )
})
